import API from "@/services/api"
import { CategoryResponse } from "../types/CRMCategorySelectField";

export enum Endpoints {
  Categories = "/crm/cases/categories/",
}

const getCategories = async (unsigned: boolean) => {
  try {
    const response = await API.get<CategoryResponse>({
      endpoint: Endpoints.Categories,
      searchParams: unsigned ? '?unsigned=true' : '',
      versions: [1]
    });
    return {
      status: response.promise.status,
      data: response.promise.data
    }
  } catch (error) {
    throw new Error("Failed to get categories. Please try again later.");
  }
}

export default {
  getCategories
};